module.exports = {
      id: "icons:pencil-usage",
      viewBox: "0 0 17 17",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:pencil-usage",
      toString: function () {
        return this.url;
      }
    }